import { useContext, useEffect } from 'react';
import { trackEvent, TrackingContext } from '@gjensidige/core-analytics';

import styles from '../video.module.css';

type Props = {
  videoId: string;
};

const QBRICK_SCRIPT = {
  id: 'qplayer',
  src: 'https://play2.qbrick.com/qplayer/loader/qplayer-loader.js'
};
const TRACKING = {
  eventAction: 'click',
  eventCategory: 'video',
  eventLabel: 'qbrick-play'
};

const QbrickPlayer = ({ videoId }: Props) => {
  const track = useContext(TrackingContext);

  useEffect(() => {
    if (document.getElementById(QBRICK_SCRIPT.id)) return; // Only load Qbrick player once
    document.body.append(
      Object.assign(document.createElement('script'), QBRICK_SCRIPT)
    );

    const handleQbrickMessage = (event: { origin: string; data: any }) => {
      const QBRICK_ORIGIN = 'https://play2.qbrick.com';
      const QBRICK_COMMAND = 'player-play';
      if (
        event?.origin !== QBRICK_ORIGIN ||
        event?.data?.command?.data !== QBRICK_COMMAND
      ) {
        return;
      }

      if (playClicked) return;
      playClicked = true;
      trackEvent(TRACKING, track.options);
    };

    let playClicked = false;

    window.addEventListener('message', handleQbrickMessage);

    return () => {
      window.removeEventListener('message', handleQbrickMessage);
    };
  }, [track.options]);
  return (
    <div
      className={styles.videoContainer}
      data-qplayer-account-id="1583217"
      data-qplayer-autoplay="false"
      data-qplayer-media-id={videoId}
      data-qplayer-mute="false"
      data-qplayer-preset-id="Enterprise"
    />
  );
};

export default QbrickPlayer;
